import React from 'react';
import moment from 'moment';

const Logs = ({ userLogs }) => {
    const userLogReverse = [...userLogs].reverse();

    const accountLogsData = () => {
        return (
            <tbody>
                {userLogReverse.map((item) => {
                    return (
                        <tr>
                            <th scope='row'>
                                {moment(item.time).format(
                                    'dddd, MMMM Do YYYY, h:mm:ss a'
                                )}
                            </th>
                            <td>{item.type}</td>
                            <td>{item.ipAddress}</td>
                            <td>{item.clientId}</td>
                            <td>
                                {`auth_method = ${item.details.auth_method} , username =
                                ${item.details.username}`}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        );
    };

    return (
        <div
            style={{
                boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
            }}
            className='card no-border mb-5 m-md-3 pt-4 pb-5 d-flex align-items-center'
        >
            <div className='card-body'>
                <h2 className='card-header no-border text-center mb-5'>
                    Account Log
                </h2>
                <div className='w-100 table-container'>
                    <table class='table table-striped'>
                        <thead>
                            <tr>
                                <th scope='col'>Date</th>
                                <th scope='col'>Event</th>
                                <th scope='col'>IP</th>
                                <th scope='col'>Client</th>
                                <th scope='col'>DETAILS</th>
                            </tr>
                        </thead>
                        {accountLogsData()}
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Logs;
